import { useMemo } from "react";
import PropTypes from "prop-types";

import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import configs from "./configs";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

function ActivityEfficiencyBarChart({
  color,
  title,
  description,
  date,
  chart,
  showPercent = true,
  showHours = false,
}) {
  const { data, options } = configs(chart.labels || [], chart.datasets || [], showPercent, showHours);

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox padding="1rem">
        {useMemo(
          () => (
            <MDBox
              variant="gradient"
              bgColor={color}
              borderRadius="lg"
              coloredShadow={color}
              py={2}
              pr={0.5}
              height="20rem"
            >
              <Bar data={data} options={options} redraw />
            </MDBox>
          ),
          [chart],
        )}

        <MDBox pt={3} pb={1} px={1}>
          <MDTypography variant="h6">{title}</MDTypography>

          <MDTypography
            component="div"
            variant="button"
            color="text"
            fontWeight="light"
          >
            {description}
          </MDTypography>

          <Divider />

          <MDBox display="flex" alignItems="center">
            <MDTypography variant="button" color="text" fontWeight="light">
              {date}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

ActivityEfficiencyBarChart.defaultProps = {
  color: "info",
  description: "",
};

ActivityEfficiencyBarChart.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  date: PropTypes.string.isRequired,
  chart: PropTypes.object.isRequired,
  showPercent: PropTypes.bool,
  showHours: PropTypes.bool,
};

export default ActivityEfficiencyBarChart;
